import {Component, OnInit, signal} from '@angular/core';
import {Utils} from '../../utils.class';
import {SubscriptionsService} from '../../services/subscriptions.service';
import {Subscription} from '../../classes/subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {AfasService} from '../../services/afas.service';
import {AfasArticle} from '../../classes/afas-article';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CodaltComponent} from '../../codalt.component';
import {JsonPipe} from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import {MatFormField, MatInput} from '@angular/material/input';
import {Company} from '../../classes/company';
import {CompanyService} from '../../services/company.service';
import {Routenames} from '../../classes/route-name.enum';
import {BreadcrumbComponent} from '../../services/breadcrumb/breadcrumb.component';
import {FieldErrorComponent} from '../../field-error/field-error.component';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';

@Component({
    selector: 'app-subscription-edit',
    templateUrl: './subscription-edit.component.html',
    styleUrls: ['./subscription-edit.component.scss'],
    imports: [
        ReactiveFormsModule,
        JsonPipe,
        NgSelectModule,
        MatFormField,
        MatInput,
        BreadcrumbComponent,
        FieldErrorComponent,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatIcon,
        MatIconButton
    ]
})
export class SubscriptionEditComponent extends CodaltComponent implements OnInit {

    readonly form = signal<FormGroup>(null);
    readonly subscription = signal<Subscription>(null);
    readonly companies = signal<Company[]>([]);
    utils = Utils;

    constructor(
        private afasService: AfasService,
        private companyService: CompanyService,
        private confirmDialog: ConfirmDialogService,
        private route: ActivatedRoute,
        private router: Router,
        private subscriptionsService: SubscriptionsService,
    ) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(this.companyService.getCompanies().subscribe(companies => {
            this.companies.set(companies);
        }));

        this.subscriptions.add(
            this.route.params.subscribe((params: { id }) => {
                if (params.id === 'new') {
                    this.createForm(new Subscription());
                } else {
                    this.subscriptions.add(
                        this.subscriptionsService.getSubscription(params.id).subscribe({
                            next: res => this.createForm(res),
                            error: err => console.error(err)
                        })
                    );
                }
            })
        );
    }

    createForm(subscription: Subscription) {
        this.crumbs = [
            {name: 'Abonnement', route: this.Routenames.subscriptions},
            {name: `Abonnement : ${subscription.id || 'new'}`, route: `${this.Routenames.subscriptions}/${subscription.id || 'new'}`}
        ];

        this.subscription.set(subscription?.id ? subscription : new Subscription());

        this.form.set(new FormGroup({
            id: new FormControl(subscription.id),
            company_id: new FormControl(subscription.company_id, [Validators.required]),
            description: new FormControl(subscription.description),
            comment: new FormControl(subscription.comment, [Validators.required]),
            count_url: new FormControl(subscription.count_url),
            count: new FormControl(subscription.count, [Validators.required]),
            price: new FormControl(subscription.price),
            repeat: new FormControl(subscription.repeat),
            last_date: new FormControl(subscription.last_date, [Validators.required])
        }));
    }

    save() {
        Utils.triggerValidation(this.form());
        if (this.form().valid) {
            const subscription = new Subscription();
            Object.assign(subscription, this.form().value);
            this.subscriptions.add(
                this.subscriptionsService.save(this.form().value).subscribe({
                    next: () => this.router.navigate([Routenames.subscriptions]),
                    error: err => console.error(err)
                })
            );
        }
    }

    openDelete(event) {
        event.preventDefault();
        event.stopPropagation();

        const subscription = new Subscription();
        Object.assign(subscription, this.form().value);

        this.confirmDialog.confirm(
            'Verwijderen',
            `Weet u zeker dat u abbonement ${subscription.id} wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        )
            .then(() => {
                this.subscriptionsService.delete(subscription.id)
                    .then(() => {
                        this.router.navigate([Routenames.subscriptions]);
                    })
            })
            .catch(() => {
                console.log('platform not deleted')
            });
    }
}
